export default __webpack_public_path__ + "static/media/Alessio_Aprile_Silver_tree_50_x_70_cm.bc52dfb1.jpg";